const Styles = {
  container: {
    width: '100%',
    minHeight: '100vh',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    position: 'absolute',
  },
  cardContainer: {
    px: 1,
    width: '100%',
    height: '100vh',
    mx: 'auto',
  },
  cardHeaderContainer: {
    mx: 2,
    mt: -3,
    p: 2,
    mb: 1,
    textAlign: 'center',
  },
  cardBodyContainer: {
    pt: 4,
    pb: 3,
    px: 3,
  },
  forgotPassTxt: {
    mt: 1,
    mb: 2,
  },
  youWillReceiveEmailTxt: {
    mt: 1,
    mb: 2,
  },
  forgotPassBtnView: {
    mt: 3,
    mb: 2,
  },
  backBtnView: {
    mb: 1,
    textAlign: 'center',
  },
};

export default Styles;
